import styled from "styled-components";

export const Wrapper = styled.div`
  .main-container {
    padding-bottom: 80px;
  }
`;
